import { render, staticRenderFns } from "./ModeratorPreparing.vue?vue&type=template&id=4ec2ddaa&scoped=true&"
import script from "./ModeratorPreparing.vue?vue&type=script&lang=js&"
export * from "./ModeratorPreparing.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorPreparing.vue?vue&type=style&index=0&id=4ec2ddaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2ddaa",
  null
  
)

export default component.exports